import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from "@/shared/hooks";
import { Dropdown } from "@gemini/ui";
import { Controller } from "react-hook-form";
import { preferredMoveInDateTestId } from "./constants";
import { useDropdownItems } from "./useDropdownItems";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
export const PreferredMoveInDateInput = ({ control }) => {
    const { t } = useI18n();
    const isPreviewMode = useIsPreviewMode();
    const defaultItems = useDropdownItems("contact.form.preferred_move_in_date_items", 5);
    return (_jsx(Controller, { name: "preferredMoveInDate", control: control, defaultValue: "", render: ({ fieldState: { error }, field }) => (_jsx(Dropdown, Object.assign({}, (error && {
            error: t("contact.form.preferred_move_in_date_error_empty"),
        }), field, { label: t("contact.form.preferred_move_in_date"), placeholder: t("contact.form.please_select"), testId: preferredMoveInDateTestId, defaultItems: defaultItems, isDisabled: isPreviewMode }))) }));
};
